import { SEO } from "@/components/SEO";
import { Link } from "wouter";

const BLOG_POSTS = [
    {
        id: "what-is-ragi-drink",
        title: "What Is a Ragi Drink?",
        excerpt: "A simple guide to ragi, ganji, finger millet, and why this traditional Indian drink is returning as a modern healthy beverage.",
        date: "June 18, 2026"
    },
    {
        id: "healthy-drinks-india",
        title: "Healthy Drinks in India: Why Millet Beverages Matter",
        excerpt: "From soda to packaged juices, India has many drink choices. Here is why ragi-based drinks deserve a place in the market.",
        date: "June 18, 2026"
    },
    {
        id: "sweet-vs-salt-ganji",
        title: "Sweet Ganji vs Salt Ganji",
        excerpt: "Which Ganji Drinks flavor should you try first? A quick guide for people discovering traditional ragi beverages.",
        date: "June 18, 2026"
    },
    {
        id: "product-testing",
        title: "The Journey of Product Testing",
        excerpt: "Behind every bottle of Ganji is months of rigorous testing, tasting, and refining to get the perfect blend of tradition and taste.",
        date: "January 5, 2026"
    },
    {
        id: "we-are-hiring",
        title: "We Are Hiring",
        excerpt: "Join the Ganjidrinks family! We are looking for passionate individuals to help us build the next big desi beverage brand.",
        date: "January 8, 2026"
    }
];

export default function Blog() {
    return (
        <div className="min-h-screen bg-background text-foreground pb-12">
            <SEO
                title="Ragi Drink Blog | Ganji Drinks Stories, Health & Millet Beverage Guides"
                description="Read Ganji Drinks guides on ragi drinks, healthy Indian beverages, millet nutrition, Sweet Ganji, Salt Ganji, product testing, and our brand story."
                keywords="ragi drink blog, healthy drinks India, millet beverages, ganji benefits, sweet ganji, salt ganji, traditional Indian drinks"
            />

            {/* Empty Header for Spacing (Logo is global fixed) */}
            <nav className="p-4 md:p-6 flex justify-center items-center pointer-events-none sticky top-0 z-40 bg-transparent">
                <div className="h-10 w-auto opacity-0" aria-hidden="true">
                    {/* Spacer to keep layout consistent if needed, or just invisible. 
                        Actually user wants 'header should be empty'. 
                        We can remove nav content entirely or just keep height. 
                        Global logo is at top-4 left-4. 
                        Let's just remove the nav content but keep a spacer if needed for layout flow, 
                        or minimal spacer. 
                        The global logo is fixed. 
                     */}
                </div>
            </nav>

            <main className="container mx-auto px-4 pt-8 md:pt-12 max-w-4xl">
                {/* Back Button */}
                <div className="mb-8">
                    <Link href="/">
                        <a className="inline-flex items-center gap-2 hover:opacity-75 transition-opacity"
                            style={{ color: 'hsl(var(--ganji-rustic-brown))' }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M19 12H5" />
                                <path d="M12 19l-7-7 7-7" />
                            </svg>
                            <span className="text-lg" style={{ fontFamily: "'Patrick Hand', cursive" }}>Back</span>
                        </a>
                    </Link>
                </div>

                <h1
                    className="text-4xl md:text-6xl mb-12 text-center"
                    style={{ fontFamily: "'Permanent Marker', cursive", color: 'hsl(var(--ganji-rustic-brown))' }}
                >
                    Ganji Stories
                </h1>

                <div className="grid gap-8 md:grid-cols-2">
                    {BLOG_POSTS.map((post) => (
                        <Link key={post.id} href={`/blog/${post.id}`}>
                            <a className="group block h-full">
                                <article
                                    className="h-full p-6 rounded-xl border border-border shadow-sm hover:shadow-md transition-shadow bg-card"
                                    style={{ backgroundColor: 'hsl(var(--ganji-warm-cream))' }}
                                >
                                    <span className="text-sm text-muted-foreground mb-2 block">{post.date}</span>
                                    <h2
                                        className="text-2xl mb-3 group-hover:underline decoration-2 underline-offset-4"
                                        style={{ fontFamily: "'Patrick Hand', cursive", color: 'hsl(var(--ganji-rustic-brown))' }}
                                    >
                                        {post.title}
                                    </h2>
                                    <p className="opacity-80 leading-relaxed text-sm md:text-base">
                                        {post.excerpt}
                                    </p>
                                    <span className="mt-4 inline-block text-sm font-medium opacity-70 group-hover:opacity-100 transition-opacity">
                                        Read more →
                                    </span>
                                </article>
                            </a>
                        </Link>
                    ))}
                </div>
            </main>
        </div>
    );
}
